export default function AdvisoryOverview() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative order-2 lg:order-1">
          <img
            src="/assets/images/site/adv-overview-001-800x700.jpg"
            alt="Harambee Global Ventures advisory services cross-border wealth creation"
            className="w-full h-[520px] object-cover object-top rounded-lg"
          />
          {/* Floating accent card */}
          <div className="absolute -bottom-6 -right-6 bg-[#1A4D3C] text-white rounded-lg p-6 max-w-[230px] hidden md:block">
            <div className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#C9A961] mb-1">
              Phased
            </div>
            <div className="text-white/70 text-xs leading-relaxed">
              Relationship-driven advisory model &mdash; built on education, trust, and long-term strategic growth
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Advisory Overview
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            A Platform Built for Clarity, Discipline, and Long-Term Growth
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-5">
            Harambee Global Ventures is an education, investment, and advisory platform built to support intergenerational wealth creation across the African Diaspora. Our advisory services are the natural extension of our educational mission &mdash; designed to help clients move from awareness to action with structure and confidence.
          </p>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            We take a relationship-based, phased approach. We begin with education and trust-building, then provide structured advisory conversations that help qualified clients navigate cross-border opportunities, family office considerations, and long-term wealth-building pathways with clarity and discipline.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              {
                icon: "ri-shake-hands-line",
                title: "Relationship-Based",
                desc: "We lead with trust, not transactions. Every advisory engagement begins with understanding your goals.",
              },
              {
                icon: "ri-route-line",
                title: "Structured Pathways",
                desc: "Clear, phased guidance from investor readiness to advanced wealth-building strategies.",
              },
              {
                icon: "ri-earth-line",
                title: "Cross-Border Focus",
                desc: "Nairobi-anchored with global perspective &mdash; built for diaspora and international clients.",
              },
              {
                icon: "ri-time-line",
                title: "Long-Term Perspective",
                desc: "We prioritize sustainable, intergenerational wealth creation over short-term gains.",
              },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <div className="font-semibold text-[#2B2D2F] text-sm mb-1">
                    {item.title}
                  </div>
                  <div className="text-[#6B6B6B] text-xs leading-relaxed">
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
